import React from 'react';
import LoginShell from '../components/LoginShell';
import LoginForm from '../components/LoginForm';

export default function LoginPage() {
  return (
    <LoginShell>
      <LoginForm />
    </LoginShell>
  );
}
